import React from 'react';
export function Footer() {
  return <footer className="bg-[#2A3E3E] text-beige/50 py-12 px-4 text-xs font-sans" data-id="element-148">
      <div className="max-w-layout mx-auto" data-id="element-149">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-150">
          <a href="#" className="hover:text-beige transition-colors" data-id="element-151">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-beige transition-colors" data-id="element-152">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-beige transition-colors" data-id="element-153">
            Aviso Legal
          </a>
          <a href="#" className="hover:text-beige transition-colors" data-id="element-154">
            Contacto
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-center max-w-4xl mx-auto leading-relaxed opacity-80" data-id="element-155">
          <p className="mb-4" data-id="element-156">
            DESCARGO DE RESPONSABILIDAD: Este producto tiene fines educativos y
            no sustituye asesoramiento médico o psicológico profesional. Los
            resultados pueden variar según la aplicación individual. Este sitio
            no está afiliado con ninguna plataforma médica o institución de
            salud.
          </p>
          <p data-id="element-157">
            © {new Date().getFullYear()} Sistema R.E.S.T.A.U.R.A™. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}